import { Breadcrumb, Card, Icon, message, Popconfirm, Row, Tabs } from 'antd'
import Email from '../../../../../api/Email'
import Receipts from '../../../../../api/Sales/Receipts'
import Templates from '../../../../../api/Templates'
import Documents from '../../../../../components/Common/Documents/DocumentsCont'
import EmailCont from '../../../../../components/Common/Email/EmailCont'
import RefreshButton from '../../../../../elements/Buttons/RefreshButton'
import CustomSpin from '../../../../../elements/CustomSpin'
import { MODAL_TYPE_NEW } from '../../../../../elements/Hooks/useModalData'
import useModalShow from '../../../../../elements/Hooks/useModalShow'
import useSubmit from '../../../../../elements/Hooks/useSubmit'
import useTitle from '../../../../../elements/Hooks/useTitle'
import IconText from '../../../../../elements/IconText'
import Status from '../../../../../elements/Status'
import { get } from 'lodash'
import Authentication from '../../../../../modules/Authentication'
import { dateFormat, dateVal, idMaker, moneyInline, numVal, strVal } from '../../../../../modules/Utils'
import React, { useState } from 'react'
import { streamUrl } from '../../../../../variables/index'
import History from '../../../../Common/History'
import style from '../../style.css'
import Details from './Details'

const { TabPane } = Tabs
const auth = new Authentication()
const templateApi = new Templates()
const emailApi = new Email()
const receiptsApi = new Receipts()
const ids = idMaker()

function ViewReceipt(props) {
  const { receipt, fetch, fetching, handleOps, actions, type } = props
  const isNew = type === MODAL_TYPE_NEW

  const isUpdatable = isNew ? true : actions.find((a) => a.key === 'update')
  const isConfirmed = receipt.status === 'Confirmed'

  const [_3, submitTemplate] = useSubmit(templateApi.read, true)
  const [_1, submitReceiptTemplate] = useSubmit(emailApi.receiptTemplate, true)
  const [_2, submitReceiptFiles] = useSubmit(receiptsApi.files, true)
  const [_4, getListLine] = useSubmit(receiptsApi.lines.list, true)

  const [emailTemplate, setEmailTemplate] = useState('')
  const [emailDetails, setEmailDetails] = useState('')
  const [emailFiles, setEmailFiles] = useState([])
  const [emailLines, setEmailLines] = useState([])

  const { visible: visibleEmail, onShow: onShowEmail, onCancel: onCancelEmail } = useModalShow(async () => {
    let hide = message.loading('Fetching Email Template ...', 0)
    const listLine = await getListLine(receipt._key)
    console.log({ listLine })
    const emailLines = [
      {
        _id: receipt._id,
        _key: receipt._key,
        ref: strVal(receipt, 'transaction.remittance.ref'),
        date: dateFormat(dateVal(receipt, 'date')),
        no: receipt.revision ? strVal(receipt, 'code') + '.0' + strVal(receipt, 'revision') : strVal(receipt, 'code'),
        amount: moneyInline(numVal(receipt, 'allocated'), strVal(receipt, 'currency')),
      },
    ]
    setEmailLines(emailLines)
    // date, ref, amount, no

    const company = get(receipt, 'company._id', '').replace('members/', '')
    const mrnTemplate = await submitTemplate(company, 'receipt')
    const emailDetails = get(mrnTemplate, 'email') || {}
    console.log({ emailDetails })
    const data = await submitReceiptTemplate({
      receiver: get(receipt, 'payableRep.fn'),
      companyRep: get(receipt, 'companyRep.fn'),
      company: get(receipt, 'company.fn'),
      address: get(receipt, 'company.address.label'),
      phone: get(receipt, 'company.phone.label'),
      lines: emailLines,
      ...emailDetails,
    })

    const filesList = await submitReceiptFiles([receipt._id])
    setEmailFiles(filesList)
    const filesMapped = filesList.map((f) => f.uuid)
    setEmailTemplate(data.html)
    setEmailDetails({
      to: get(receipt, 'payableRep.email.label'),
      cc: get(receipt, 'company.email.label'),
      bcc: get(emailDetails, 'bcc'),
      from: get(emailDetails, 'from'),
      subject: `[${get(receipt, 'code')}] ${get(emailDetails, 'subject')}`,
      attachments: filesMapped,
    })
    // setEmailLines([receipt])
    hide()
  })

  useTitle(`${receipt.code} Receipt`)
  const Operations = ({ receipt, ...rest }) => {
    const ops = actions.map((a) => (
      <span>
        <Popconfirm
          placement="left"
          title={`Are you sure to ${a.value}?`}
          onConfirm={() => handleOps(a.key, receipt)}
          okText="Yes"
          cancelText="No">
          <a>{a.value}</a>
        </Popconfirm>
      </span>
    ))

    if (ops.length > 0 && isConfirmed) {
      ops.push(
        <a onClick={onShowEmail}>
          <IconText text={'Send Email'} type={'mail'} />
        </a>
      )
    }

    ops.push(
      <a target={'_blank'} href={`${streamUrl}pdf/${receipt._id}?access_token=${auth.getAccessToken()}`}>
        <IconText text={'PDF preview'} type={'file-pdf'} />
      </a>,
      <RefreshButton onClick={fetch} />
    )
    return (
      <div {...rest}>
        {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider" />, curr]) : []}
      </div>
    )
  }
  return (
    <CustomSpin spinning={fetching}>
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Sales</Breadcrumb.Item>
            <Breadcrumb.Item href="#/clients/payments/#receipts">Receipts</Breadcrumb.Item>
            <Breadcrumb.Item>{receipt.code}</Breadcrumb.Item>
          </Breadcrumb>
          <div className={style.title}>
            <h2 className={'icon-text-header'}>
              <Icon
                type="barcode"
                style={{
                  marginRight: '5px',
                  color: '#08c',
                }}
              />
              {strVal(receipt, 'code').trim()}
            </h2>
            <h3 className={'icon-text-header'}>{strVal(receipt, 'title').trim()}</h3>
            <Status style={{ float: 'right' }} value={strVal(receipt, 'status')} />
            <Operations style={{ marginTop: '10px' }} receipt={receipt} status={strVal(receipt, 'status')} />
          </div>
        </Row>
      </Card>
      {/*<ReceiptModal {...props} />*/}
      <Row style={{ paddingTop: '10px' }}>
        <EmailCont
          key={ids.next().value}
          visible={visibleEmail}
          onCancel={onCancelEmail}
          template={emailTemplate}
          email={emailDetails}
          files={emailFiles}
          lines={emailLines}
        />
        <Card style={{ minHeight: '542px' }}>
          <Row style={{ paddingTop: '10px' }}>
            {/*<BillLineModal isUpdatable={isUpdatable} {...props} />*/}
            <Tabs defaultActiveKey="dashboard">
              <TabPane
                tab={
                  <span>
                    <Icon type="info-circle" />
                    Details
                  </span>
                }
                key="dashboard">
                <Details isUpdatable={isUpdatable} {...props} />
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <Icon type="copy" />
                    History
                  </span>
                }
                key="history">
                <History loading={fetching} owner={receipt} />
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <Icon type="folder-open" />
                    Documents
                  </span>
                }
                key="documents">
                <Documents editable={true} email={true} owner={receipt} />
              </TabPane>
            </Tabs>
          </Row>
        </Card>
      </Row>
    </CustomSpin>
  )
}

ViewReceipt.propTypes = {}
ViewReceipt.defaultProps = {}

export default ViewReceipt
